$(() => {
    const chevron = $('[menu-chevron-mobile]');
    const menuItem = $('[menu-item]');
    const subMenuItem = $('[submenu-list]');
    
    chevron.click((e) => {
        $(e.target).closest(menuItem).find(subMenuItem).eq(0).slideToggle();
        $(e.target).toggleClass('open');
    });
});
